import { createFileRoute } from '@tanstack/react-router';

import { TOOL_GATES, ToolAccessGate } from 'shared/modules/capabilities';
import { LOCATION_DATA_UNAVAILABLE_PAGE } from 'shared/modules/country-support';

import { ReplyTemplates, replyTemplatesSearchSchema } from 'features/reports/reviews/ReplyTemplates';

export const Route = createFileRoute('/_authenticated/locations/$id/_shell/reviews/manager/templates')({
  staticData: { breadcrumb: 'replyTemplates' },
  validateSearch: replyTemplatesSearchSchema,
  component: ReplyTemplatesRoute
});

function ReplyTemplatesRoute() {
  const { id } = Route.useParams();
  const { templatesSort } = Route.useSearch();

  return (
    <ToolAccessGate
      gate={TOOL_GATES.REVIEWS}
      locationId={id}
      page={LOCATION_DATA_UNAVAILABLE_PAGE.REVIEW_MANAGER}
      titleKey="reports.replyTemplates.title"
    >
      <ReplyTemplates locationId={id} templatesSort={templatesSort} />
    </ToolAccessGate>
  );
}
